<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="Mitsubishi O-Ring"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    Mitsubishi O-Ring
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/oring/oring-top-img.png"
            className="h-lg-400px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    MITSUBISHI CABLE is a Japanese company with a history of about 100 years since its foundation in 1917.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Rubber O-Ring products have been produced since 1958 at the request of the Japanese Ministry of Defense.
                </p>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Through the know-how gained through long experience, we are expanding innovative solutions based on our core competencies,
                    material composite technology, design technology, and production engineering.
                </p>
                <p class="page-text color-grey-51">
                    The selection of materials is very wide, and the optimal design according to the order is applied,  and it is receiving high recommendations and interest from various industries.
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Advantages">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">
                        We can supply rubber O-Rings (EPDM, Silicon, FKM) and Metal O-Rings to all fields,  and our product line responds to a wide range of industrial fields. <br>
                        We always welcome inquiries about O-Rings requested at the device design stage.
                    </p>
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon1.png"
                        iconWidth="49"
                        num="01">
                        Very wide material selection
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon2.png"
                        iconWidth="50"
                        num="02">
                        Apply the optimal design according to the order
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon3.png"
                        iconWidth="49"
                        num="03">
                        Can supply Rubber O-Ring and Metal O-Ring to all fields
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/oring/oring-icon4.png"
                        iconWidth="50"
                        num="04">
                        The product line can respond to a wide range of industries
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout
                tit="Mitsubishi O-Ring"
                className="full">

                    <v-row class="my-n10 my-lg-n40">
                        <v-col cols="12" md="6" class="py-10 py-lg-40">
                            <image-detail
                            tit="Metal O-ring"
                            src="/images/sub/distributor/oring/oring-img3-1.png">

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-4 mb-lg-20">
                                    Under severe conditions such as high temperature and high pressure,
                                    MITSUBISHI CABLE Metal O-ring can maintain and
                                    withstand high sealing properties in severe ultra-high vacuum and cryogenic temperatures
                                </p>

                                <p class="bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8">
                                    - Possibility of use in 270 °C ~ +700 °C
                                </p>
                                <p class="bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8">
                                    - Ultra High Vacuum : (1.3×10-10Pa)
                                </p>
                                <p class="bar-txt font-size-14 font-size-lg-16 color-grey-2c">
                                    - Steady sealing performance at ultra-high pressure : 300MPa (3000kgf /cm2)
                                </p>

                            </image-detail>
                        </v-col>
                        <v-col cols="12" md="6" class="py-10 py-lg-40">
                            <image-detail
                            tit="Rubber Seal"
                            src="/images/sub/distributor/oring/oring-img3-2.png">

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10">
                                    With the know-how gained through the manufacture of integrated sealing materials,  which has manufactured/supplied rubber sealing of
                                    many different materials, we provide solutions to meet  each request through the best blend of
                                    optimum shape design capabilities.
                                </p>

                            </image-detail>
                        </v-col>
                    </v-row>

                </sub-line-layout>
            </v-container>
        </section>

        <div class="sub-section sub-section--last">
            <v-container>

                <inquiry
                src="/images/sub/distributor/oring/oring-img1.png"
                name="D.H YOO"
                tel="+82-31-765-2268"
                mail="davidyoo@ist-co.kr"
                fax="+82-31-765-2389"
                link="https://www.mitsubishi-cable.co.jp/en/products/group/seal/index.html"
                linkBg="/images/sub/distributor/oring/oring-img2.png">
                </inquiry>

            </v-container>
        </div>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/en/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
import ImageDetail from "@/components/client/en/sub/sub-image-detail.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
        ImageDetail,
    },
};
</script>

<style lang="scss" scoped>
</style>